import { usePageContext } from "../components/Layout";

export type AltLang = {
	lang: string,
	name: string;
	url: string;
}

export function useAltLang(): AltLang {
	const { pageMeta: { lang, alts }} = usePageContext();
	const alt  = alts.find(a => a.lang !== lang) ?? altDefault(lang);
	return { ...alt, name: LANGS[alt.lang].name }
}

const LANGS: {[lang: string]: { name: string, home: string}} = {
	sk: { name: 'Slovensky', home: '/' },
	en: { name: 'English', home: '/en/' },
}

export function langHomeUrl(lang: string) {
	return LANGS[lang]?.home ?? '/';
}

function altDefault(lang: string) {
	return lang === 'sk'
		? { lang: 'en', url: langHomeUrl('en') }
		: { lang: 'sk', url: langHomeUrl('sk') };
}
